export default __webpack_public_path__ + "static/media/cont10.24c7f8cc.jpeg";